export const isScrollOnBottom = (containerElement: HTMLUListElement | null) => {
  if (!containerElement) {
    return false;
  }

  return containerElement.scrollHeight === Math.ceil(containerElement.scrollTop + containerElement.clientHeight);
};
